import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { apiPublic } from '../utils/apiService';
import { BusinessOrderCheckout } from './BusinessOrderCheckout';
import { BusinessOrder } from './types';
const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

export default function BusinessOrderPage() {
  const { orderId } = useParams();
  const [data, setData] = useState<{
    snapshot: BusinessOrder;
    quote_token: string;
  } | null>(null);
  const [error, setError] = useState('');
  const [receipt, setReceipt] = useState<string | null>(null);
  const url = `${API_BASE_URL}/api/public/business-orders/${orderId}/`;
  useEffect(() => {
    let active = true;
    setData(null);
    setError('');
    apiPublic
      .get(url)
      .then(async (response) => {
        const body = await response.json();
        if (!response.ok)
          throw new Error(body.detail || 'This Order is unavailable.');
        if (active) setData(body);
      })
      .catch((e) => active && setError(e.message));
    return () => {
      active = false;
    };
  }, [url]);
  if (error)
    return (
      <main className="mx-auto max-w-3xl p-10">
        <h1 className="text-2xl font-semibold">Business Order unavailable</h1>
        <p role="alert" className="mt-4">
          {error}
        </p>
        <p>No agreement was accepted or payment collected.</p>
      </main>
    );
  if (!data)
    return (
      <p role="status" className="p-10">
        Loading your Order…
      </p>
    );
  return (
    <>
      <BusinessOrderCheckout
        order={data.snapshot}
        quoteToken={data.quote_token}
        onAccept={async (input) => {
          const response = await apiPublic.post(url, input);
          const body = await response.json();
          if (!response.ok) {
            throw new Error(body.detail || 'Acceptance could not be recorded.');
          }
          setReceipt(body.document_html || null);
        }}
      />
      {receipt && (
        <div className="mx-auto max-w-5xl p-5">
          <button
            className="rounded border p-3 underline"
            onClick={() => {
              const url = URL.createObjectURL(
                new Blob([receipt], { type: 'text/html' }),
              );
              const link = document.createElement('a');
              link.href = url;
              link.download = 'accepted-askarthur-agreement.html';
              link.click();
              window.setTimeout(() => URL.revokeObjectURL(url), 1000);
            }}
          >
            Download your accepted agreement
          </button>
        </div>
      )}
    </>
  );
}
